import { HttpClient } from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AnnuaireProfessionnelsSanteService } from '../annuaire-professionnels-sante/annuaire-professionnels-sante.service';
import { RessourceService } from '../ressource/ressource.service';
import { MssApicryptService } from './mss.apicrypt.service';
import { MssMockService } from './mss-mock.service';
import { MssServiceAbstract } from './mss-service.abstract';
import { MssMailizService } from './mss.mailiz.service';

export class MSSNotAuthorizedError extends Error {

}

// const mssServiceAbstract = (
//     apsSrv: AnnuaireProfessionnelsSanteService,
//     httpClient: HttpClient,
//     resourceSrv: RessourceService
// ) => {
//   if (environment.mssMock) {
//     return new MssMockService(apsSrv);
//   } else {
//     // return new ApicryptService(httpClient);
//     return new MssApicryptService(httpClient, resourceSrv);
//     // return new MssService(httpClient, apsSrv, resourceSrv);
//   }
// };

// export const mssServiceProvider: Provider = {
//   provide: MssServiceAbstract,
//   useFactory: mssServiceAbstract,
//   deps: [
//     AnnuaireProfessionnelsSanteService,
//     HttpClient,
//     RessourceService
//   ]
// };

export enum MssTypeService {
  mock = 'mock',
  mailiz = 'mailiz',
  apicrypt = 'apicrypt',
}

@Injectable({
  providedIn: 'root'
})
export class MssServiceFactory {
  private _typeService: MssTypeService;

  constructor(
    private _mssMockService: MssMockService,
    private _mssApicryptService: MssApicryptService,
    private _mssMailizService: MssMailizService,
  ) { }

  public getService(): MssServiceAbstract {
    switch (this._typeService) {
      case MssTypeService.mock:
        return this._mssMockService;
      case MssTypeService.mailiz:
        return this._mssMailizService;
      case MssTypeService.apicrypt:
        return this._mssApicryptService;
      default:
        return this._mssMockService;
    }
  }

  public switchService(srv: MssTypeService): void {
    this._typeService = srv;
  }

  public get typeService(): MssTypeService {
    return this._typeService;
  }
}
